import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/shouye.vue'),
  },
  {
    path: '/yewuxuanze',
    name: 'yewuxuanze',
    component: () => import('@/views/yewuxuanze.vue'),
  },
  {
    path: '/baoting',
    name: 'baoting',
    component: () => import('@/views/yewu/baoting.vue'),
  },
  {
    path: '/baoxiu',
    name: 'baoxiu',
    component: () => import('@/views/yewu/baoxiu.vue'),
  },
  {
    path: '/baozhuang',
    name: 'baozhuang',
    component: () => import('@/views/yewu/baozhuang.vue'),
  },
  {
    path: '/chaxun',
    name: 'chaxun',
    component: () => import('@/views/yewu/chaxun.vue'),
  },
  {
    path: '/tousu',
    name: 'tousu',
    component: () => import('@/views/yewu/tousu.vue'),
  },
  {
    path:'/lianhechaxun',
    name:'lianhechaxun',
    component:()=>import('@/views/chaxun.vue')
  },
  {
    path:'/lianhebaozhuang',
    name:'lianhebaozhuang',
    component:()=>import('@/views/lianhebaozhuang.vue')
  },
  {
      path:'/pc',
    name:'pc',
    component:()=>import('@/views/pc.vue')
  }


]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
